var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7,7.875A3.938,3.938,0,1,0,3.063,3.938,3.939,3.939,0,0,0,7,7.875Zm3.5.875H8.993a4.76,4.76,0,0,1-3.987,0H3.5A3.5,3.5,0,0,0,0,12.25v.438A1.313,1.313,0,0,0,1.312,14H12.688A1.313,1.313,0,0,0,14,12.688V12.25A3.5,3.5,0,0,0,10.5,8.75Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/user-icon.145099d326f39e3646ba06fa89816d65.svg";
export { ForwardRef as ReactComponent };